'use client';

import { checkHeadlineForSpecialChars } from "@/frontend/utils/headlineChars";
import { ContentSize } from "../../ui/section";
import { ButtonContainer } from "../../ui/button";
import { CTAArray } from "../../ui/content/cta-elements";
import clsx from "clsx";
import { Page as PageType } from "@/payload-types";

export const BackgroundHeroContentBlock = ({ content }: { content: PageType['hero'] }) => {
  const ctaArray = content?.ctaArray;
  const openSlots = content?.headlineGroup?.openSlots;

  return (
    <div className={clsx('content-block', 'in-view')}>
      <ContentSize>
        <div className="headline-container">
          <h1>{checkHeadlineForSpecialChars(content?.headlineGroup?.title)}</h1>
          {content?.headlineGroup?.subtitle && <p className="subline">{content?.headlineGroup?.subtitle}</p>}
        </div>
        { !openSlots && !ctaArray?.length ? null : (
          <div className="button-content-block">
            { ctaArray?.length ? (
              <ButtonContainer alignment="center">
                <CTAArray ctaArray={ctaArray} />
              </ButtonContainer>
            ): null }
            { openSlots && 
              <div className="slots-block">
                <span className="slots-point"></span>
                <span className="slots-text">{openSlots}</span>
              </div> 
            }
          </div>
        )}
      </ContentSize>
    </div>
  );
};